module.exports = __webpack_public_path__ + "3454a36dfc0fa2bb4e1a3c782eff8c77.png";